import React, { Component } from 'react';
import { headerActions } from 'actions/HeaderActions';
import { mapActions } from 'actions/MapActions';
import { createHash } from 'utils/Utilities';

export class Header extends Component {
  constructor(props) {
    super(props);
  }

  toogleMeasureTool() {
    headerActions.hideBasemapGallery();
    headerActions.hideShareLink();
    headerActions.toogleMeasureTool();
  }

  toggleBasemapGallery() {
    headerActions.hideMeasureTool();
    headerActions.hideShareLink();
    headerActions.toggleBasemapGallery();
  }

  toggleShareLink() {
    headerActions.hideMeasureTool();
    headerActions.hideBasemapGallery();
    headerActions.toggleShareLink();
    mapActions.setHash(createHash());
  }

  render() {
    return (
      <div id={'header'} className={'header blue darken-3'}>
        <nav className={'blue darken-3'}>
          <div className={'nav-wrapper'}>
            <div className='header-title'>ASCE Hazard Tool</div>
            {/* <div className='beta-container'>
              <div className='beta-title'>Beta Version</div>
              <a href="https://forms.office.com/r/uQR4JpiwYq" target='_blank'>
                <span>Post Feedback</span>
              </a>
            </div> */}
            <ul className={'header-navigation-container'}>
              <li>
                <a id={'nav-measure'} className='white-text text-darken-4 nav-item' onClick={this.toogleMeasureTool}>
                  <i className={'material-icons left header-icon measure-icon'} />
                  <span>Measure</span>
                </a>
              </li>

              <li>
                <a id={'nav-basemap'} className='white-text text-darken-4 nav-item' onClick={this.toggleBasemapGallery}>
                  <i className={'material-icons left header-icon basemap-icon'} />
                  <span>Basemap</span>
                </a>
              </li>

              <li>
                <a className='white-text text-darken-4 nav-item' onClick={this.toggleShareLink}>
                  <i className={'material-icons left header-icon share-icon'} />
                  <span>Share</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}
